import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncentiveDashboardComponent } from './pages/incentive-dashboard/incentive-dashboard.component';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { UserRole } from '@reenstudio/app/core/enum/user-role';
import { PaymentsPageComponent } from './pages/payments-page/payments-page.component';
import { DistributionPageComponent } from './pages/distribution-page/distribution-page.component';
import { CalculatePageComponent } from './pages/calculate-page/calculate-page.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Incentivi',
    },
    children: [
      {
        path: 'dashboard',
        component: IncentiveDashboardComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          title: 'Riepilogo incentivi',
          urls: [
            { title: 'Incentivi', url: '/incentive/dashboard' },
            { title: 'Dashboard' },
          ],
          permissions: {
            only: [UserRole.ADMIN, UserRole.CER, UserRole.INTRAPRESA],
          },
        },
      },
      {
        path: 'payments',
        component: PaymentsPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          title: 'Pagamenti GSE',
          urls: [
            { title: 'Incentivi', url: '/incentive/dashboard' },
            { title: 'Pagamenti GSE' },
          ],
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
        },
      },
      {
        path: 'distribution',
        component: DistributionPageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          title: 'Ripartizione incentivi',
          urls: [
            { title: 'Incentivi', url: '/incentive/dashboard' },
            { title: 'Ripartizione' },
          ],
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
        },
      },
      {
        path: 'calculate',
        component: CalculatePageComponent,
        canActivate: [ngxPermissionsGuard],
        data: {
          title: 'Calcolo incentivi',
          urls: [
            { title: 'Incentivi', url: '/incentive/dashboard' },
            { title: 'Calcolo' },
          ],
          permissions: {
            only: [
              UserRole.ADMIN,
              UserRole.CER,
              UserRole.INTRAPRESA,
              UserRole.SITE,
            ],
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IncentiveRoutingModule {}
